import { withStyles } from '@mui/styles';
import QuestionsPage from './questions-page';
import { styles } from './questions-page.styles';

export default withStyles(styles, { withTheme: true })(QuestionsPage);
